import React from 'react';
import Toast, { ToastType } from './Toast';
import { Z_INDEX } from '../../utils/zIndex';

export interface ToastItem {
	id: string;
	type: ToastType;
	message: string;
	duration?: number;
}

interface ToastContainerProps {
	toasts: ToastItem[];
	onRemove: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemove }) => {
	return (
		<div
			className="fixed top-4 left-1/2 transform -translate-x-1/2 space-y-2"
			style={{ zIndex: Z_INDEX.TOAST }}
		>
			{toasts.map((toast) => (
				<Toast
					key={toast.id}
					id={toast.id}
					type={toast.type}
					message={toast.message}
					duration={toast.duration}
					onClose={onRemove}
				/>
			))}
		</div>
	);
};

export default ToastContainer;
